document.addEventListener("DOMContentLoaded", () => {

  const date = document.getElementById("delivery_date");
  const slot = document.getElementById("delivery_time");
  const radios = document.querySelectorAll(
    'input[name="attributes[Delivery Method]"]'
  );

  // Minimum date = tomorrow
  let tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  date.min = tomorrow.toISOString().split('T')[0];

  const deliverySlots = [
    "09:00 AM - 12:00 PM",
    "12:00 PM - 03:00 PM",
    "03:00 PM - 06:00 PM",
    "06:00 PM - 09:00 PM"
  ];

  const pickupSlots = [
    "10:00 AM - 12:00 PM",
    "12:00 PM - 02:00 PM",
    "02:00 PM - 04:00 PM",
    "04:00 PM - 06:00 PM",
    "06:00 PM - 08:00 PM"
  ];

  function loadSlots() {
    slot.innerHTML = '<option value="">Select Time Slot</option>';

    const method = document.querySelector(
      'input[name="attributes[Delivery Method]"]:checked'
    ).value;

    const slots = method === "Delivery" ? deliverySlots : pickupSlots;

    slots.forEach(s => {
      const option = document.createElement("option");
      option.value = s;
      option.textContent = s;
      slot.appendChild(option);
    });
  }

  loadSlots();

  radios.forEach(r => {
    r.addEventListener("change", loadSlots);
  });

  // Prevent checkout if fields are empty
  const form = document.getElementById("cart");

  form.addEventListener("submit", function(e) {

    if (date.value === "" || slot.value === "") {
      e.preventDefault();
      alert("Please choose a delivery/pickup date and time slot.");
    }

  });

});